import {
  learnDashGET,
  REMBLE_API_URL,
  REMBLE_WP_API_URL,
  cleanCourseItem
} from '.'
import { LMS_TYPE_PREFIX } from './Courses'

/* =============================================
 * Public methods
 * ============================================= */

/**
 * Tries to retrieve assessment options from an Assessment question
 * @param {Object} question Question Instance from LearnDash
 */
const getAssessmentOptionsFromQuestion = question => {
  const regex = /([^[]+(?=]))/g
  return question._answerData[0]._answer.match(regex)
}

/**
 * Retrieves all quizzes for a given Course, Lesson and Topic, or an empty array if none are found.
 * @param {Number} courseId The CourseId to use when looking up quizzes
 * @param {Number} lessonId The LessonId to use when looking up quizzes
 * @param {Number} topicId The TopicId to use when looking up quizzes
 * See https://developers.learndash.com/rest-api/v1/v1-quizzes/ for more info.
 */
const getQuizzesForCourseLessonTopic = async (courseId, lessonId, topicId) => {
  const url = `${REMBLE_API_URL}/lms/`
  const quizzes = await learnDashGET(url, {
    uri: `/${LMS_TYPE_PREFIX}quiz`,
    course: courseId,
    lesson: lessonId,
    topic: topicId
  })

  return quizzes ? quizzes.map(quiz => cleanCourseItem(quiz)) : []
}

/**
 * Retrieves a Quiz given its ID. See https://developers.learndash.com/rest-api/v1/v1-quizzes/ for more info.
 * @param {Number} quizId The Quiz ID to lookup.
 */
const getQuizById = async quizId => {
  const url = `${REMBLE_API_URL}/lms/`
  const quiz = await learnDashGET(url, {
    uri: `/${LMS_TYPE_PREFIX}quiz/${quizId}`
  })

  return quiz.error ? quiz : cleanCourseItem(quiz)
}

/**
 * Retrieves the Questions and results messages for a Quiz given its ID. See https://github.com/Remble/com.remble.www/blob/main/wordpress/wp-content/mu-plugins/remble-api.php for more info.
 * @param {Number} quizId The Quiz ID to lookup Questions for.
 */
const getQuizDetails = async quizId => {
  const url = `${REMBLE_WP_API_URL}/quiz/${quizId}`
  const data = await learnDashGET(url)

  return data
}

export {
  getAssessmentOptionsFromQuestion,
  getQuizzesForCourseLessonTopic,
  getQuizById,
  getQuizDetails
}
